
import { FrequencyType } from "@/models/base";
import { RepeatedTask } from "@/models/tasks/repeated-task";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppSettingsMonthly from "../frequency/FrequencySettingsMonthly.vue";
import AppSettingsMonthlyPerWeek from "../frequency/FrequencySettingsMonthlyPerWeek.vue";
import AppSettingsWeekly from "../frequency/FrequencySettingsWeekly.vue";
import AppSettingsYearly from "../frequency/FrequencySettingsYearly.vue";
import AppTaskPriorityChips from "./TaskPriorityChips.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>RepeatedTask,
			required: true
		}
	},
	computed: {
		frequencyTypeItems():ISelectItem<FrequencyType>[]{
			return [
				{
					text: this.$ct("weekly"),
					value: FrequencyType.Weekly
				},
				{
					text: this.$ct("monthly"),
					value: FrequencyType.Monthly
				},
				{
					text: this.$ct("monthly-per-week"),
					value: FrequencyType.MonthlyPerWeek
				},
				{
					text: this.$ct("yearly"),
					value: FrequencyType.Yearly
				}
			];
		},
		isWeekly():boolean {
			return this.value.FrequencyType == FrequencyType.Weekly;
		},
		isMonthly():boolean {
			return this.value.FrequencyType == FrequencyType.Monthly;
		},
		isMonthlyPerWeek():boolean {
			return this.value.FrequencyType == FrequencyType.MonthlyPerWeek;
		},
		isYearly():boolean {
			return this.value.FrequencyType == FrequencyType.Yearly;
		},
	},
	methods: {
		setFrequencyType(value:FrequencyType){
			this.value.FrequencyType = value;

			let date = new Date();
			let weekday = date.getDay();
			if (weekday < 0) {
				weekday = 6;
			}
			if (this.value.FrequencyType == FrequencyType.Weekly) {
				this.value.FrequencyMoment = `${weekday}`;
			} else if (this.value.FrequencyType == FrequencyType.Monthly) {
				this.value.FrequencyMoment = `${date.getDate()}`;
			} else if (this.value.FrequencyType == FrequencyType.MonthlyPerWeek) {
				this.value.FrequencyMoment = `1/${weekday}`;
			} else if (this.value.FrequencyType == FrequencyType.Yearly) {
				this.value.FrequencyMoment = `${date.getDate()}/${date.getMonth() + 1}`;
			}
		}
	},
	components: {
		AppSettingsWeekly,
		AppSettingsMonthly,
		AppSettingsMonthlyPerWeek,
		AppSettingsYearly,
		AppTaskPriorityChips
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
